import { Component } from '@angular/core';

@Component({
  selector: 'spinner',
  imports: [],
  templateUrl: './spinner.html',
  styleUrl: './spinner.css',
})
export class Spinner {

  public loading: string = "Loading...";

}
